import './assets/App.css';

import { Routes, Route } from 'react-router-dom';
import MainLayout from './mainLayout';
import ProtectedRoute from './general/protectedRoute';
import HomePage from './pages/home';
import ProfilePage from './pages/profile';
import AdminRoute from './general/adminRoute';
import AdminUsersPage from './pages/adminUsers';
import AdminModulesPage from './pages/adminModules';
import ForbiddenPage from './pages/forbidden';
import NotFoundPage from './pages/notFound';
import ActivitiesPage from './pages/activities';
import HelpPage from './pages/help';
import AdminCoursesPage from './pages/adminCourses';
import ManagedModuleEditorPage from './components/content-creator/managed-module-editor-page';
import AdminThemesPage from './pages/adminThemes';
import AdminProtectedStoragePage from './pages/adminProtectedStorage';
import ProductsPage from './pages/products';
import PricingPage from './pages/pricing';
import ServicesPage from './pages/services';
import ReviewsPage from './pages/reviews';
import AdminReviewsPage from './pages/adminReviews';
import AdminAnalyticsPage from './pages/adminAnalytics';
import AdminFinancePage from './pages/adminFinance';
import AdminTasksPage from './pages/adminTasks';
import AdminDebugPage from './pages/adminDebug';
import Config from './general/config';
import AboutPage from './pages/about';
import PolicyPage from './pages/policy';
import CertificatePage from './pages/certificate';
import AdminCertificatesPage from './pages/adminCertificates';
import { PageMetadata } from './components/page-metadata';
import { OrganizationMetadata } from './components/organization-metadata';
import { AppToastProvider } from './providers/app-toast-provider';

function App() {
  // useAppState();

  return (
    <AppToastProvider>
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0, width: '100%', flex: 1 }}>
        <PageMetadata />
        <OrganizationMetadata />
        <MainLayout>
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            {Config.showServicesMenu && <Route path="/services" element={<ServicesPage />} />}
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/certificate/:key" element={<CertificatePage />} />
            <Route path="/terms-of-use" element={<PolicyPage policy="terms" />} />
            <Route path="/privacy-policy" element={<PolicyPage policy="privacy" />} />
            <Route path="/refund-policy" element={<PolicyPage policy="refunds" />} />
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/admin/activities" element={<ProtectedRoute><ActivitiesPage /></ProtectedRoute>} />
            <Route path="/admin/users" element={<AdminRoute><AdminUsersPage /></AdminRoute>} />
            <Route path="/admin/modules" element={<AdminRoute><AdminModulesPage /></AdminRoute>} />
            <Route path="/admin/courses" element={<AdminRoute><AdminCoursesPage /></AdminRoute>} />
            <Route path="/admin/certificates" element={<AdminRoute><AdminCertificatesPage /></AdminRoute>} />
            <Route path="/admin/reviews" element={<AdminRoute><AdminReviewsPage /></AdminRoute>} />
            <Route path="/admin/analytics" element={<AdminRoute><AdminAnalyticsPage /></AdminRoute>} />
            <Route path="/admin/tasks" element={<AdminRoute><AdminTasksPage /></AdminRoute>} />
            <Route path="/admin/finance" element={<AdminRoute><AdminFinancePage /></AdminRoute>} />
            <Route path="/admin/managedModuleEditor" element={<AdminRoute><ManagedModuleEditorPage /></AdminRoute>} />
            <Route path="/admin/themes" element={<ProtectedRoute><AdminThemesPage /></ProtectedRoute>} />
            <Route path="/admin/protectedStorage" element={<AdminRoute><AdminProtectedStoragePage /></AdminRoute>} />
            <Route path="/admin/help" element={<ProtectedRoute><HelpPage /></ProtectedRoute>} />
            {Config.env === 'local' && <Route path="/admin/debug" element={<AdminRoute><AdminDebugPage /></AdminRoute>} />}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </MainLayout>
    </div>
    </AppToastProvider>
  );
}

export default App;
